import { CountdownTimer } from '@appsumo/dorado-react';
import { ReactElement } from 'react';
import { useBanner } from '~/lib/util/useBanner';

interface BannerProps {
  timerText: string;
  displayTimer?: boolean;
}

// TODO: Implement remaingin banner functionality (close, CTA link)
export default function Banner({
  timerText,
  displayTimer = false,
}: BannerProps): ReactElement {
  const { bannerItem } = useBanner();

  if (!bannerItem?.id) {
    return <></>;
  }

  return (
    <div
      role="banner"
      className="flex w-full justify-center py-1.5"
      style={{
        backgroundColor: bannerItem.background_color,
        color: bannerItem.text_color,
      }}
    >
      {bannerItem.text}
      {displayTimer && (
        <>
          &nbsp;
          <CountdownTimer
            datetime={bannerItem.end_date as Date}
            timerText={timerText}
          />
        </>
      )}
    </div>
  );
}
